module.exports = __webpack_public_path__ + "assets/img/picture2.a8be20e4.jpg";